import { modules } from '@config';
import Select from '@common/Forms/Select';
import cx from 'classnames';
import { storeConfigVar } from '@core/services/graphql/cache';

export const generateLabelSort = (keyValue, sortValue) => {
    switch (`${keyValue}-${sortValue}`) {
    case 'name-asc':
        return 'Nama Produk';
    case 'name-desc':
        return 'Nama Produk';
    case 'price-asc':
        return 'Termurah';
    case 'price-desc':
        return 'Termahal';
    case 'new_arrivals-asc':
        return 'Terbaru';
    case 'bestseller-desc':
        return 'Terlaris';
    case 'discount_price-asc':
        return 'Diskon Terkecil';
    case 'discount_price-desc':
        return 'Diskon Terbesar';
    case 'most_popular-asc':
        return 'Produk Populer';
    case 'position-asc':
        return 'Paling Sesuai';
    case 'stock_index-asc':
        return 'Ketersediaan Stok';
    case 'accessories_type-asc':
        return 'Accessories Type';
    default:
        return 'Paling Sesuai';
    }
};

export const generateCatalogSorting = (isSearch) => {
    let updatedSort;
    const baseSort = [
        { value: { key: 'bestseller', value: 'DESC' }, label: 'Terlaris' },
        { value: { key: 'discount_price', value: 'DESC' }, label: 'Diskon Terbesar' },
        { value: { key: 'discount_price', value: 'ASC' }, label: 'Diskon Terkecil' },
        { value: { key: 'price', value: 'ASC' }, label: 'Termurah' },
        { value: { key: 'price', value: 'DESC' }, label: 'Termahal' },
    ];
    const catalogSort = [
        { value: { key: 'mostviewed', value: 'DESC' }, label: 'Produk Populer' },
    ];
    const searchSort = [
        { value: { key: 'mostviewed', value: 'DESC' }, label: 'Produk Populer' },
    ];

    const storeConfig = storeConfigVar();
    const [keyDefaultSortCatalog = 'position', valueDefaultSortCatalog = 'asc'] = storeConfig.catalog_default_sort_by.split('~');

    const handleKeyDefaultSort = (keySorting) => {
        if (keySorting) {
            if (keySorting === 'most_popular') {
                return 'mostviewed';
            } if (keySorting === 'best_sellers') {
                return 'bestseller';
            }
            return keySorting;
        }
        return 'position';
    };

    const handleValueDefaultSort = (keySorting, valueSorting = 'asc') => {
        if (keySorting || valueSorting) {
            return keySorting === 'most_popular' || keySorting === 'discount_price'
                || keySorting === 'best_sellers' ? 'DESC' : valueSorting.toUpperCase();
        }
        return 'ASC';
    };

    const defaultSort = [
        {
            value: {
                key: handleKeyDefaultSort(keyDefaultSortCatalog),
                value: handleValueDefaultSort(keyDefaultSortCatalog, valueDefaultSortCatalog),
            },
            label: generateLabelSort(keyDefaultSortCatalog, handleValueDefaultSort(keyDefaultSortCatalog, valueDefaultSortCatalog).toLowerCase()),
        },
    ];

    if (isSearch) {
        updatedSort = [...searchSort, ...baseSort];
    } else {
        updatedSort = [...catalogSort, ...baseSort];
        const isKeyExist = updatedSort.some((item) => item.value.key === defaultSort[0].value.key || item.value.key === 'best_sellers');

        // insert default sort if key not exist
        if (!isKeyExist) {
            updatedSort = [...defaultSort, ...catalogSort, ...baseSort];
        }
    }

    const { catalog } = modules;
    const sortList = catalog.productListing.sort;
    sortList[keyDefaultSortCatalog] = true;
    updatedSort = updatedSort.filter((sort) => sortList[sort.value.key]).map((updatedSortData) => ({
        ...updatedSortData,
        value: JSON.stringify({ key: updatedSortData.value.key, value: updatedSortData.value.value }),
    }));
    return updatedSort;
};

const Sorting = (props) => {
    const {
        isSearch, filterValue, setFiltervalue, t, plpClassSort = '',
    } = props;

    const sortByData = React.useMemo(() => generateCatalogSorting(isSearch), []);

    const [selectedFilter, setFilter] = React.useState(filterValue);
    const [value, setValue] = React.useState(selectedFilter.sort);

    const handleChange = (event) => {
        const savedData = {
            selectedFilter,
        };
        if (value !== '') {
            savedData.sort = event;
            setValue(event);
        }

        setFiltervalue(savedData);
    };

    const shortingValue = sortByData.filter((item) => item.value === value);

    React.useEffect(() => {
        setFilter(filterValue);
        setValue(selectedFilter.sort);
    }, [filterValue]);

    return (
        <div className="flex items-center desktop:w-[auto] tablet:w-auto mobile:w-[50%] tablet:pl-0 mobile:pl-[0.25rem]">
            <label className="uppercase tracking-wider text-neutral-500 desktop:block tablet:block mobile:hidden">
                {t('catalog:title:short')}
            </label>
            <Select
                options={sortByData}
                onChange={handleChange}
                placeholder={t('catalog:title:short')}
                className="h-[38px]"
                value={shortingValue && shortingValue.length > 0 ? shortingValue[0].label : ''}
                textFiledProps={{
                    className: cx('swift-sorter-options h-[38px] tablet:h-auto !w-[auto] ml-2 tablet:-mt-[1px] !rounded-none',
                        'tablet:ml-2 mobile:ml-0 desktop:!border-neutral-200 mobile:!border-neutral-300'),
                    rightIconProps: {
                        className: '!text-neutral-600',
                    },
                }}
                inputProps={{
                    className: cx(
                        'h-[34px] !font-normal placeholder:!text-neutral placeholder:!font-normal',
                        plpClassSort,
                    ),
                }}
            />
        </div>
    );
};

export default Sorting;
